import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { RadioGroup, Radio } from 'react-radio-group';

import Spinner from '../shared/Spinner';
import PlayerViewBoxscore from './PlayerViewBoxscore';
import PlayerViewSummary from './PlayerViewSummary';
import PlayerAdvancedStats from './PlayerAdvancedStats';
import PlayerOnOff from './PlayerOnOff';
import PlayerViewShooting from './PlayerViewShooting';

const PlayerView = ({ player, onOffType, handleOnOffChange }) => (
  <div className="s-player-view">
    {player ? (
      <React.Fragment>
        <div className="s-player-view__header">
          <PlayerViewSummary player={player} />
        </div>

        <div className="s-player-view__stats">
          <Tabs defaultIndex={0}>
            <TabList className="nav-pills">
              <Tab className="nav-pills__item">Totals</Tab>
              <Tab className="nav-pills__item">Adv. Stats</Tab>
              <Tab className="nav-pills__item">On/Off</Tab>
              <Tab className="nav-pills__item">Shooting Profile</Tab>
              <Tab className="nav-pills__item" disabled={true}>
                Impact
              </Tab>
            </TabList>

            <TabPanel>
              <PlayerViewBoxscore player={player} />
            </TabPanel>
            <TabPanel>
              <PlayerAdvancedStats player={player} />
            </TabPanel>
            <TabPanel>
              <RadioGroup
                className="radio-selector"
                name="onOffType"
                selectedValue={onOffType}
                onChange={handleOnOffChange}
              >
                <label>
                  <Radio value="offense" /> Offense
                </label>
                <label>
                  <Radio value="defense" /> Defense
                </label>
              </RadioGroup>
              <PlayerOnOff
                player={player}
                isDefense={onOffType === 'defense'}
              />
            </TabPanel>
            <TabPanel>
              <PlayerViewShooting player={player} />
            </TabPanel>
            <TabPanel>Impact goes here</TabPanel>
          </Tabs>
        </div>
      </React.Fragment>
    ) : (
      <Spinner />
    )}
  </div>
);

PlayerView.propTypes = {
  player: PropTypes.object,
};

export default PlayerView;
